import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { ChangePasswordPayload, SendEmailResponce } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';

export const useChangePassword = () => {
  const mutate = async (payload: ChangePasswordPayload) => {
    const { data } = await api.changePassword(payload);

    return data;
  };

  const mutationKey = MutationKeys.changePassword;

  return useMutation<SendEmailResponce, AxiosError<ApiError>, ChangePasswordPayload>(
    mutationKey,
    mutate,
  );
};
